import { combineReducers } from "redux";
import {MovieHomePage,DetailMovie,FetCatagory,SearchMV,SimilarMovies,fetbrowseMovies } from "./MovieReducer";
export default combineReducers({
    MovieHomePage: MovieHomePage,
    DetailMovie: DetailMovie,
    FetCatagory:FetCatagory,
    SearchMV:SearchMV,
    SimilarMovies: SimilarMovies,
    fetbrowseMovies:fetbrowseMovies
})